import * as React from 'react';
import { toast } from 'react-toastify';

interface DriverJobsSiteDeparturePartItemsProps {
    partCompleteJob: PartCompleteJob;
    back(): void;
    update(partCompleteJob: PartCompleteJob): void;
    next(): void;
}

interface DriverJobsSiteDeparturePartItems {
    loading: boolean;
    showValidation: boolean;
    errors: any;
}

interface PartCompleteJob {
    jobItems: DriverJobItems[];
    notes: string;
}

interface DriverJobItems {
    id: number;
    kwikstageId: number;
    unitNumberDisplay: string;
    type: string;
    typeId: number;
    item: string;
    itemId: number;
    quantity: number;
    itemQuantityType: string;
    estimatedTime: string;
    estimatedTimeMins: number;
    isComplete: boolean;
    percentComplete: number;    //used for Kwikstage
    vehicleItemOrder: number;   //used when adding manual job after a linked job
    itemParts: ItemPart[];
    other: boolean;
    otherDisabled: boolean;
}

interface ItemPart {
    itemPartId: number;
    part: string;
    isComplete: boolean;
}

export default class DriverJobsSiteDeparturePartItemsData extends React.Component<DriverJobsSiteDeparturePartItemsProps, DriverJobsSiteDeparturePartItems> {
    constructor(props: DriverJobsSiteDeparturePartItemsProps) {
        super(props);

        this.state = {
            loading: false,
            showValidation: false,
            errors: {}
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    back = (e: any) => {
        e.preventDefault();

        this.props.back();
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        this.setState({ errors: errors })
        this.props.update(e.target.value);
    }

    handleItemChange = (e: any, index: number) => {
        var partCompleteJob = this.props.partCompleteJob;
        var jobs = partCompleteJob.jobItems;
        var job = jobs[index];
        job.percentComplete = e.target.value;

        this.props.update(partCompleteJob);
    }

    handleCheckboxChange = (e: any, index: number) => {
        var partCompleteJob = this.props.partCompleteJob;
        var jobs = partCompleteJob.jobItems;
        var job = jobs[index];
        job.isComplete = e.target.checked;

        this.props.update(partCompleteJob);
    }

    handleOtherCheckboxChange = (e: any, itemIndex: number) => {
        var partCompleteJob = this.props.partCompleteJob;
        var jobs = partCompleteJob.jobItems;
        var item = jobs[itemIndex];

        item.other = e.target.checked;

        this.props.update(partCompleteJob);
    }

    handleCellCheckboxChange = (e: any, itemIndex: number, partIndex: number) => {
        var partCompleteJob = this.props.partCompleteJob;
        var jobs = partCompleteJob.jobItems;
        var item = jobs[itemIndex];
        var part = item.itemParts[partIndex];
        part.isComplete = e.target.checked;

        var itemsChecked = item.itemParts.filter(i => i.isComplete);
        if (e.target.checked || itemsChecked.length > 0) {
            item.other = false;
            item.otherDisabled = true;
        } else if (itemsChecked.length === 0) {
            item.otherDisabled = false;
        }

        this.props.update(partCompleteJob);
    }

    handleChangeText = (e: any) => {
        var partCompleteJob = this.props.partCompleteJob;
        partCompleteJob.notes = e.target.value;
        this.props.update(partCompleteJob);
    }

    validate = () => {
        let jobItems = this.props.partCompleteJob.jobItems;
        let errors: any = {};
        let formIsValid = true;

        for (var i = 0; i < jobItems.length; i++) {
            var jobItem = jobItems[i];
            if (jobItem.itemId === 4 && jobItem.percentComplete < 0) {
                formIsValid = false;
            }
        }

        let otherSelected = jobItems.filter(i => i.other).length > 0;
        if (otherSelected && !this.props.partCompleteJob.notes) {
            formIsValid = false;
            errors["notes"] = "Notes are required when ticking Other";
            this.setState({ errors: errors });
        }

        this.setState({ showValidation: true });
        return formIsValid;
    }

    next = (e: any) => {
        e.preventDefault();
        if (this.validate()) {
            this.props.next();
        } else {
            toast.error("Please fix validation errors!");
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var isKsItems = this.props.partCompleteJob.jobItems.filter(p => p.itemId === 4).length > 0;

        return (
            <div>
                <div className="mobileFont marginTop10 marginBottom10">
                    <div className="makeitflexspacebetween marginBottom10">
                        <h2 className="mobile-margin">Job Partially Complete</h2>
                        <i className="mobile-icon-grey fas fa-arrow-alt-circle-left mobileMenuSize" onClick={(e) => this.back(e)}></i>
                    </div>

                    <div>Tick <span className="makeitred makeitbold">ONLY</span> items that have been <span className="makeitred makeitbold">FULLY</span> complete</div>
                    <div className={isKsItems ? "" : "hidden"}><span className="makeitred makeitbold">Kwikstage Items</span> - Select % Complete</div>
                    <table className="table__full marginBottom10">
                        <tbody>
                            {this.props.partCompleteJob.jobItems.map((item, index) =>
                                <React.Fragment key={index}>
                                    <tr>
                                        <td>
                                            {item.unitNumberDisplay === "" ? "" : item.unitNumberDisplay + " - "}
                                            {item.type}
                                        </td>
                                        <td className="makeitbold">
                                            {item.item}
                                        </td>
                                        <td>
                                            {item.itemQuantityType}
                                        </td>
                                        <td className={item.itemParts.length === 0 ? "driverjobs-part--checkcenter" : "hidden"}>
                                            <input type='checkbox' id="isComplete" name="isComplete" className={item.itemId === 4 ? "hidden" : 'checkbox driverjobs-part--check'} checked={item.isComplete} onChange={(e) => this.handleCheckboxChange(e, index)}></input>
                                            <select className={item.itemId === 4 ? "select" : "hidden"} id="percentComplete" name="percentComplete" value={item.percentComplete} onChange={(e) => this.handleItemChange(e, index)}>
                                                <option value={-1}></option>
                                                <option value={0}>0</option>
                                                <option value={10}>10</option>
                                                <option value={20}>20</option>
                                                <option value={30}>30</option>
                                                <option value={40}>40</option>
                                                <option value={50}>50</option>
                                                <option value={60}>60</option>
                                                <option value={70}>70</option>
                                                <option value={80}>80</option>
                                                <option value={90}>90</option>
                                                <option value={100}>100</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr className={this.state.showValidation && item.itemId === 4 && item.percentComplete < 0 ? "" : "hidden"}>
                                        <td colSpan={4}>
                                            <span className="makeitred">Select the % complete for Kwikstage Item</span>
                                        </td>
                                    </tr>
                                    <tr className={item.itemParts.length === 0 ? "hidden" : ""}>
                                        <td colSpan={3}>
                                            <table className="makeitflexcenter">
                                                <tbody>
                                                    {item.itemParts.map((part, partIndex) =>
                                                        <tr key={part.itemPartId}>
                                                            <td className="driverjobs-part--width">
                                                                {part.part}
                                                            </td>
                                                            <td className="driverjobs-part--checkcenter">
                                                                <input type='checkbox' id="isComplete" name="isComplete" className='checkbox driverjobs-part--check' checked={part.isComplete} onChange={(e) => this.handleCellCheckboxChange(e, index, partIndex)}></input>
                                                            </td>
                                                        </tr>
                                                    )}
                                                    <tr>
                                                        <td className="driverjobs-part--width">
                                                            Other
                                                        </td>
                                                        <td className="driverjobs-part--checkcenter">
                                                            <input type='checkbox' id="isComplete" name="isComplete" className='checkbox driverjobs-part--check' checked={item.other} onChange={(e) => this.handleOtherCheckboxChange(e, index)} disabled={item.otherDisabled}></input>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>

                                    </tr>
                                    <tr className={item.itemParts.length === 0 ? "hidden" : ""}>
                                        <td colSpan={3}>
                                            <span>NOTE: Tick Other if job has started but no items have been fully completed.</span>
                                            <hr></hr>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            )}
                        </tbody>
                    </table>
                    <div>
                        <label className="input-group" htmlFor="notes">
                            <span className="label-mobile">Additional Notes</span>
                            <textarea className="input job__noteSize label-mobile" maxLength={500} id="notes" name="notes" value={this.props.partCompleteJob.notes} onChange={(e) => this.handleChangeText(e)}></textarea>
                        </label>
                        <span className="label errors">{this.state.errors["notes"]}</span>
                    </div>
                    <div className="defaultbutton__container--right marginTop10">
                        <i className="mobile-icon-green fas fa-arrow-alt-circle-right mobileMenuSize" onClick={(e) => this.next(e)}></i>
                    </div>
                </div>
            </div>
        );

    }
}
